// extracted by mini-css-extract-plugin
export default {"bullet":"bullet_bullet__N4U27"};